import {
  REQUEST_STATS_CLAIMS,
  SET_STATS_CLAIMS,
} from 'containers/HomePage/constants';

export const requestStatsClaims = (count: any) => {
  return {
    type: REQUEST_STATS_CLAIMS,
    count,
  };
};

export const setStatsClaims = (statsClaims: any) => ({
  type: SET_STATS_CLAIMS,
  statsClaims,
});
